export default __webpack_public_path__ + "static/media/facebook.b43cf06e.svg";